import Spinners from "components/Common/Spinner"
import React from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  TabContent,
  TabPane,
} from "reactstrap"

const CustomerDetailsLeftCard = ({
  customerDetailsOpened,
  setCustomerDetailsComponentOpened,
  singleBtn,
  setSingleBtn,
  activeTab,
  setActiveTab,
  editTabVisible,
  setEditTabVisible,
  deleteCustomer,
  currentActiveTab,
  setCurrentActiveTab,
  UserJPG,
  customer,
  isLoading,
  setLoading,
}) => {
  const userData = useSelector(state => state.Login.userData)
  const mode = useSelector(state => state.Layout.layoutMode)
  return (
    <Card
      style={{
        borderRadius: "20px",
      }}
      className="chat-leftsidebar"
    >
      <CardBody style={{ maxHeight: "fit-content", overflow: "hidden" }}>
        <div className="text-center bg-light rounded px-4 py-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="text-start">
              <span
                className="mdi mdi-arrow-left"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setCustomerDetailsComponentOpened(false)
                }}
              ></span>
            </div>
            <div className="text-end">
              {userData.role !== "viewer" && (
                <Dropdown
                  className="chat-noti-dropdown"
                  isOpen={singleBtn}
                  toggle={() => setSingleBtn(!singleBtn)}
                >
                  <DropdownToggle tag="a" className="p-0">
                    <i
                      style={{
                        color: mode === "dark" ? "#fff" : "#2990DF",
                      }}
                      className="mdi mdi-cog"
                    ></i>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem
                      onClick={() => {
                        setEditTabVisible(true)
                      }}
                    >
                      Edit
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        deleteCustomer()
                      }}
                    >
                      Delete
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              )}
            </div>
          </div>
          <div className="chat-user-status">
            <img src={UserJPG} className="avatar-md rounded-circle" alt="" />
          </div>
          <h5 className="font-size-16 mb-1 mt-3">
            {customer.firstName} {customer.lastName}
          </h5>
          <p className="text-muted mb-0">{customer.email}</p>
          <p className="text-muted mb-0">{customer.contact}</p>
        </div>
      </CardBody>

      {isLoading ? (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinners setLoading={setLoading} />
        </div>
      ) : (
        <div className="chat-leftsidebar-nav">
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <div className="chat-message-list" style={{ height: "100%" }}>
                <ul
                  className="list-unstyled chat-list p-3"
                  style={{ height: "100%" }}
                >
                  <div>
                    <li
                      className={currentActiveTab === "Visits" ? "active" : ""}
                      style={{
                        backgroundColor:
                          currentActiveTab === "Visits"
                            ? "rgba(41,144,223,0.1)"
                            : "transparent",
                        borderRadius: "10px",
                      }}
                    >
                      <Link
                        to="#"
                        onClick={() => setCurrentActiveTab("Visits")}
                        style={{
                          color:
                            currentActiveTab === "Visits"
                              ? "#2990DF"
                              : "inherit",
                          textDecoration: "none",
                          display: "block",
                          padding: "10px",
                        }}
                      >
                        <div className="d-flex align-items-center mt-2">
                          <div className="flex-grow-1 overflow-hidden">
                            <h5
                              className="text-truncate font-size-15 mb-0"
                              style={{
                                color:
                                  currentActiveTab === "Visits"
                                    ? "#2990DF"
                                    : "inherit",
                              }}
                            >
                              Visits
                            </h5>
                            <p
                              className="text-muted mb-0 mt-1 text-truncate"
                              style={{
                                color:
                                  currentActiveTab === "Visits"
                                    ? "#2990DF"
                                    : "rgba(108,117,125,0.9)",
                              }}
                            >
                              Select to display details of customer visits
                            </p>
                          </div>
                        </div>
                      </Link>
                    </li>

                    <li
                      className={currentActiveTab === "Surveys" ? "active" : ""}
                      style={{
                        backgroundColor:
                          currentActiveTab === "Surveys"
                            ? "rgba(41,144,223,0.1)"
                            : "transparent",
                        borderRadius: "10px",
                      }}
                    >
                      <Link
                        to="#"
                        onClick={() => setCurrentActiveTab("Surveys")}
                        style={{
                          color:
                            currentActiveTab === "Surveys"
                              ? "#2990DF"
                              : "inherit",
                          textDecoration: "none",
                          display: "block",
                          padding: "10px",
                        }}
                      >
                        <div className="d-flex align-items-center mt-2">
                          <div className="flex-grow-1 overflow-hidden">
                            <h5
                              className="text-truncate font-size-15 mb-0"
                              style={{
                                color:
                                  currentActiveTab === "Surveys"
                                    ? "#2990DF"
                                    : "inherit",
                              }}
                            >
                              Surveys
                            </h5>
                            <p
                              className="text-muted mb-0 mt-1 text-truncate"
                              style={{
                                color:
                                  currentActiveTab === "Surveys"
                                    ? "#2990DF"
                                    : "rgba(108,117,125,0.9)",
                              }}
                            >
                              Select to display details of customer surveys
                            </p>
                          </div>
                        </div>
                      </Link>
                    </li>
                  </div>
                </ul>
              </div>
            </TabPane>
          </TabContent>
        </div>
      )}
    </Card>
  )
}

export default CustomerDetailsLeftCard
